import { clearLaunchCache } from "~/lib/launch-cache"
import { Capacitor } from "@capacitor/core"
import { LogOutIcon, SettingsIcon } from "lucide-react"
import { useNavigate } from "react-router-dom"
import { Link } from "~/components/Link"
import { useOrganization } from "~/hooks/useOrganization"
import { authClient } from "~/lib/auth-client"
import { clearNativeAuthToken } from "~/lib/native-auth-token"
import { EntityIdentity } from "~/components/EntityIdentity"
import { Button } from "../ui/button"
import { Command, CommandGroup, CommandItem, CommandList } from "../ui/command"
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover"

export function UserMenu() {
	const { data: session } = authClient.useSession()
	const { organization } = useOrganization()
	const navigate = useNavigate()

	const logout = async () => {
		await authClient.signOut()
		clearLaunchCache()
		if (Capacitor.isNativePlatform()) {
			clearNativeAuthToken()
			navigate("/login")
			return
		}
		window.location.assign("/")
	}

	return (
		<Popover>
			<PopoverTrigger asChild>
				<Button variant="outline" size="icon" aria-label="Account menu">
					<EntityIdentity
						kind="user"
						variant="avatar"
						size="md"
						name={session?.user?.name ?? "?"}
						image={session?.user?.image}
						lastSeenAt={
							organization?.members.find(
								(member) => member.userId === session?.user.id
							)?.user.lastSeenAt
						}
					/>
				</Button>
			</PopoverTrigger>
			<PopoverContent align="start" size="sm">
				<Command>
					<CommandList>
						<CommandGroup>
							{organization && (
								<CommandItem asChild>
									<Link to={`/${organization.slug}/me/settings`}>
										<SettingsIcon className="size-4 text-icons" /> Settings
									</Link>
								</CommandItem>
							)}
							<CommandItem onSelect={() => void logout()}>
								<LogOutIcon className="size-4 text-icons" /> Logout
							</CommandItem>
						</CommandGroup>
					</CommandList>
				</Command>
			</PopoverContent>
		</Popover>
	)
}
